import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'components/atoms';

import './NavUnit.scss';
export default function NavUnit(props) {
	const { nav, active } = props;
	const baseHref = '#';
	return (
		<div
			className="menu-wrapper"
			aria-controls="menu-scrollbar"
		>
			{nav.map((item) => (
				<div
					key={item.title}
					className={`menu-item${
						item.href.includes(active) ? ' active' : ''
					}`}
				>
					<Link
						href={item.href.includes(active) ? baseHref : item.href}
					>
						{item.title}
					</Link>
				</div>
			))}
		</div>
	);
}

NavUnit.propTypes = {
	nav: PropTypes.arrayOf(PropTypes.object),
	active: PropTypes.string,
};
